import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Usermgmt from "../../../../services/UserServices/Usermgmt";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { formatDateTime } from "../../../../Components/Common/FormatDate";

const Userdetail = () => {
  console.log("Userdetail component rendered");
  const { id } = useParams();
  const [userData, setUserData] = useState();
  console.log(id);

  useEffect(() => {
    // console.log("fired");
    const fetchDatabyId = async () => {
      try {
        console.log("fired");
        const response = await Usermgmt.getuserbyid(id);
        console.log(response);

        setUserData(response);
      } catch (error) {
        console.error("Failed to fetch user:", error);
      }
    };
    fetchDatabyId();
  }, []);

  console.log(userData);

  const breadcrumbItems = [{ title: "Back To User List", link: "/user-mgmt" }];
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Database"
          title="Database Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Card
        className=" p-4 shadow-sm border-0 w-100"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <Row className="mb-4">
          <Col
            lg={4}
            xs={12}
            className="d-flex justify-content-center align-items-center text-center mb-3"
          >
            {userData?.avatar?.path ? (
              <img
                data-dz-thumbnail=""
                height="200"
                className="avatar-xxl rounded bg-light"
                src={userData?.avatar?.path}
                alt="User Avatar"
              />
            ) : (
              <img
                data-dz-thumbnail=""
                height="200"
                className="avatar-xxl rounded bg-light"
                src={"/avatar.jpg"}
                alt="User Avatar"
              />
            )}
          </Col>
          <Col lg={1} className="d-none d-lg-block">
            <div
              className="vr"
              style={{ height: "100%", backgroundColor: "#ccc" }}
            />
          </Col>

          <Col lg={7} xs={12}>
            {/* <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
                    {userData?.username}
                  </h6> */}

            {/* <hr /> */}
            <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
              {userData?.username}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-envelope me-2"></i>
              {/* Email: {userData?.email} */}
              Email: {userData?.email || "N/A"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Phone Number : {userData?.mobile || "Invalid number"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-map-marker-alt me-2"></i>
              Registered Date : {formatDateTime(userData?.regDate)}
            </h6>
            <hr />
          </Col>
        </Row>
      </Card>
      <Row>
        {/* Database Info */}
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <CardBody>
              <h3 className="h4 mb-3">{userData?.username}</h3>
              <p className="text-muted">
                <strong>Email:</strong>{" "}
                {userData?.email || "No description available"}
              </p>
            </CardBody>
          </Card>
        </Col>

        {/* Tables Accordion */}
        <Col md={8}>
          <Card className="shadow-sm">
            <CardHeader className="border-0">
              <h5 className="mb-0">Phone Number:</h5>
            </CardHeader>
            <CardBody>
              <p>{userData?.mobile}</p>
              <p>{formatDateTime(userData?.regDate)}</p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Userdetail;
